export default __webpack_public_path__ + "static/media/pontiac.2debec45.svg";